var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"21","y":"21.4141","width":"2","height":"16.1754","transform":"rotate(-45 21 21.4141)","className":"nostroke","fill":"white","key":0}),React.createElement("rect",{"x":"22","y":"33","width":"2","height":"16.1754","transform":"rotate(-135 22 33)","className":"nostroke","fill":"white","key":1}),React.createElement("circle",{"cx":"27","cy":"27","r":"26","stroke":"white","strokeWidth":"2","key":2})]);
}

Close.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = Close;

Close.default = Close;
